export default __webpack_public_path__ + "static/media/circleTick.038cde8f.png";